@if (item) {
  <div class="program-details">
    @if (displayName()) {
      <div class="content-name">
        {{ item.name }}
      </div>
    }
    <div class="item-details">
      <div class="content-tag-line">{{ item.tagLine }}</div>
      <div class="host">
        {{ hostName }}
      </div>
      <div class="broadcast-time">
        {{ broadcastTimes }}
      </div>

      @if (item.description) {
        <div class="description">
          <hng-safe-html [htmlString]="item.description"></hng-safe-html>
        </div>
      }
    </div>
  </div>
}
